/**
 * !!!!!!!! DO NOT MODIFY THIS FILE BY HAND !!!!!!!!
 * This file was automatically generated, and any changes made here will be overwritten.
 * This has been generated by the DatabaseNameExtractionPlugin by extracting the information
 * from the manifest.json files of the models
 */
// this value is generated from the manifest.json files
export var Databases;
(function (Databases) {
    Databases["system"] = "system";
    Databases["editor"] = "editor";
    Databases["content"] = "content";
    Databases["tracking"] = "tracking";
})(Databases || (Databases = {}));
// this value is generated from the manifest.json files
export const manifestCollections = [
    'healthcheck',
    'transactions',
    'editorUserSessions',
    'editorUsers',
    'importTransactions',
    'complexModule',
    'complexModule_deleted',
    'complexPage',
    'complexPage_deleted',
    'abTesting',
    'abTesting_deleted',
    'adDefend',
    'adDefend_deleted',
    'apiTeaser',
    'apiTeaser_deleted',
    'articleList',
    'articleList_deleted',
    'articlePush',
    'articlePush_deleted',
    'articlesBox',
    'articlesBox_deleted',
    'authors',
    'authors_deleted',
    'channels',
    'channels_deleted',
    'channelizer',
    'channelizer_deleted',
    'chipWidget',
    'chipWidget_deleted',
    'contentSources',
    'contentSources_deleted',
    'cpxTrackingWhitelist',
    'cpxTrackingWhitelist_deleted',
    'ctaButton',
    'ctaButton_deleted',
    'cwcWidget',
    'cwcWidget_deleted',
    'cwcWidgetPreview',
    'cwcWidgetPreview_deleted',
    'finanzen100ChartWidget',
    'finanzen100ChartWidget_deleted',
    'galleries',
    'galleries_deleted',
    'hubPages',
    'hubPages_deleted',
    'tagEntities',
    'tagEntities_deleted',
    'images',
    'images_deleted',
    'inpageWidget',
    'inpageWidget_deleted',
    'jobs',
    'jobs_deleted',
    'linksBox',
    'linksBox_deleted',
    'menuTree',
    'menuTree_deleted',
    'movies',
    'movies_deleted',
    'multipages',
    'multipages_deleted',
    'newsArticles',
    'newsArticles_deleted',
    'contentWorkflow',
    'contentWorkflow_deleted',
    'scheduledChanges',
    'scheduledChanges_deleted',
    'newsArticleLinks',
    'newsArticleLinks_deleted',
    'newsletter',
    'newsletter_deleted',
    'paginationBucket',
    'paginationBucket_deleted',
    'partners',
    'partners_deleted',
    'pageViews',
    'videoPageViews',
    'recipes',
    'recipes_deleted',
    'redirects',
    'redirects_deleted',
    'reusableText',
    'reusableText_deleted',
    'adBlockScript',
    'adBlockScript_deleted',
    'seoWhitelist',
    'seoWhitelist_deleted',
    'sportLiveCompetitions',
    'sportLiveCompetitions_deleted',
    'sportLiveEvents',
    'sportLiveEvents_deleted',
    'sportLiveTeams',
    'sportLiveTeams_deleted',
    'staticPage',
    'staticPage_deleted',
    'tags',
    'tags_deleted',
    'videos',
    'videos_deleted',
    'videoPage',
    'videoPage_deleted',
    'imageS3CleanupState',
    'migrations',
    'apiPermissions',
    'apiUsers',
    'history',
    'history_deleted',
];
export function isTCollection(value) {
    const collectionSet = new Set(manifestCollections);
    return collectionSet.has(value);
}
export function isTDatabase(value) {
    const databaseSet = new Set(Object.values(Databases));
    return databaseSet.has(value);
}
//# sourceMappingURL=mongoDB.databases.js.map